import { ServiceIdsForMember } from '@/types/seekerCC';
import { TrafficSource, TrafficSourceType } from '@/types/seeker';
import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { useSeekerCCState, useSeekerState } from '@/components/AppState';

function useIsSinglePageEnrollment() {
  const { source, sourceType } = useSeekerState();
  const { czenServiceIdForMember } = useSeekerCCState();
  const seekerSinglePageEnrollmentFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_SEO_SEEKER_SINGLE_PAGE_ENROLLMENT
  );
  const seekerSEMSinglePageEnrollmentFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.MARTECH_SINGLE_PAGE_ENROLLMENT_MARKETING_MFE
  );

  const isCCSubService =
    czenServiceIdForMember === ServiceIdsForMember.nanny ||
    czenServiceIdForMember === ServiceIdsForMember.babysitter;

  let isSeekerSinglePageEnrollmentEligible = false;
  let isSeekerSinglePageEnrollment = false;
  let isSEMSeekerSinglePageEnrollmentEligible = false;
  const isFromSEMMfe =
    source === TrafficSource.SEM && sourceType === TrafficSourceType.SEMSeekerListings;

  if (source === TrafficSource.SEO) {
    isSeekerSinglePageEnrollmentEligible = source === TrafficSource.SEO && isCCSubService;
    isSeekerSinglePageEnrollment =
      isSeekerSinglePageEnrollmentEligible && seekerSinglePageEnrollmentFlag?.value === 2;
  } else if (isFromSEMMfe) {
    isSeekerSinglePageEnrollmentEligible = isFromSEMMfe && isCCSubService;
    isSeekerSinglePageEnrollment =
      isSeekerSinglePageEnrollmentEligible && seekerSEMSinglePageEnrollmentFlag?.value === 1;
    isSEMSeekerSinglePageEnrollmentEligible = true;
  }

  return {
    seekerSinglePageEnrollmentFlag,
    seekerSEMSinglePageEnrollmentFlag,
    isSeekerSinglePageEnrollmentEligible,
    isSeekerSinglePageEnrollment,
    isSEMSeekerSinglePageEnrollmentEligible,
  };
}

export default useIsSinglePageEnrollment;
